import { useSelector } from "react-redux";
import React from "react";
import xls from "xlsx";
import { useState, useRef } from "react";
import { useHistory, Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { Container, Row, Col } from "reactstrap";
import Dropdown from "react-bootstrap/Dropdown";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { JsonToTable } from "react-json-to-table";
import { Modal } from "react-bootstrap";
import moment from "moment";
import * as fs from "fs";
import { uploadTransaction } from "../../stores/services/beta-transaction.service";
import { getFundByAmc } from "../../stores/services/funds.service";
import { getAccountByFund } from "../../stores/services/account.service";
import { env } from "../../env";
let csvToJson = require("convert-csv-to-json");
const csv = require("csvtojson/v2");

let xlsxToJson = require("convert-excel-to-json");

const LegacyFundPortfolioUploader = () => {
    const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);

    const fileKeysMMP = ["SelectSecurityType", "SelectSecurity", "IssueDate", "MaturityDate", "CouponRate", "Yield", "CouponPayment/Year", "CouponDays", "MoneyMarketFaceValue/Unit", "TotalFaceValue", "Units", "AvgCost/Unit", "TotalCost/Amount", "MarketRate/Unit", "MarketValue", "UnrealizedGain/(Loss)", "Investmentas%ofMarketValue", "MaturityDays", "UnredeemedValue", "PrincipalAmount"]
    const fileKeysSMP = ["Market", "SelectSecurity", "TotalUnits", "AvailableUnits", "AveageCost/Unit", "TotalCost/Amount", "MarketRate/Unit", "MarketValue", "UnrealizedGain/(Loss)", "Investmentas%ofMarketValue"]
    const fileKeysTDP = ["Type", "PrincipalAmount", "InterestRate", "FromDate", "ToDate", "Bank", "Branch",]

    const downloadSampleArr = [
        { "label": "Money Market Portfolio", "path": "Money_Market_Portfolio.xlsx" },
        { "label": "Stock Market Portfolio", "path": "Stock_Market_Portfolio.xlsx" },
        { "label": "Term Deposit Portfolio", "path": "Term_Deposit_Portfolio.xlsx" },

    ];
    const history = useHistory();
    const [errorBoolean, setErrorBoolean] = useState(false);
    const amcCode = sessionStorage.getItem("amc_code") || "";
    const fund_code = JSON.parse(sessionStorage.getItem("fund_code") || "[]");
    const [loading, setLoading] = useState(false);
    const [fileData, setfileData] = useState<any>([]);
    const [fileDataCount, setFileDataCount] = useState(0);
    const myRef1 = useRef<HTMLInputElement>(null);
    const [fileName, setFileName] = useState("");
    const [fileError, setFileError] = useState("");
    const [file, setFile] = useState<any>();
    const [fileUploadingFlag, setFileUploadingFlag] = useState<boolean>(false);
    const [moneyMarket, setMoneyMarket] = useState<any>([]);

    const handleMoneyMarketValue = (data: any) => {
        let temp: any = [];
        for (var i = 0; i < data.length; i++) {
            if (data[i]["issue_date"] !== undefined) {
                data[i]["issue_date"] =
                    data[i].issue_date === ""
                        ? ""
                        : moment(data[i].issue_date).format("YYYY-MM-DD");
            }
            if (data[i]["maturity_date"] !== undefined) {
                data[i]["maturity_date"] =
                    data[i].maturity_date === ""
                        ? ""
                        : moment(data[i].maturity_date).format("YYYY-MM-DD");
            }

            if (
                !data[i]["security"]?.trim() ||
                !data[i]["security_type"]?.trim() ||
                !data[i]["total_cost_amount"]?.trim()
            ) {
                setfileData([]);
                setFileDataCount(0);
                setFileName("")
                return toast.error(
                    "Security, security Type and Total Cost Amount must be enerted in all row"
                );
            }
            if (
                data[i]["security_type"]?.trim() != "PIB" &&
                data[i]["security_type"]?.trim() != "TBILL" &&
                data[i]["security_type"]?.trim() != "SUKUK" &&
                data[i]["security_type"]?.trim() != "TFC" &&
                data[i]["security_type"]?.trim() != "CP" &&
                data[i]["security_type"]?.trim() != "TDR" &&
                data[i]["security_type"]?.trim() != "CDR" &&
                data[i]["security_type"]?.trim() != "LOP"
            ) {
                setFile("");
                setFileName("");
                return toast.error("Invalid Security type");
            }
            temp.push({
                code: data[i]["security"],
                security_type: data[i]["security_type"],
                name: data[i]["name"],
                issue_date: data[i]["issue_date"],
                maturity_date: data[i]["maturity_date"],
                coupon_rate: data[i]["coupon_rate_ percentage"],
                yield: data[i]["yield_percentage"],
                coupon_payment: data[i]["coupon_payment_year"],
                coupon_days: data[i]["coupon_days"],
                mmface_value: data[i]["money_market_face_value_unit"],
                total_face_value: data[i]["total_face_value"],
                units: data[i]["units"],
                average_cost_per_unit: data[i]["avg_cost_unit"],
                total_amount: data[i]["total_cost_amount"],
                market_rate_per_unit: data[i]["market_rate_unit"],
                market_value: data[i]["market_value"],
                unrealized_gain_loss: data[i]["unrealized_gain_loss"],
                investment_percentage_market_value:
                    data[i]["investment_as_percentage_of_market_value"],
                days_of_maturity: data[i]["maturity_days"],
                unredeem_value: data[i]["unredeemed_value"],
                principal_amount: data[i]["principal_amount"],
            });
        }

        setfileData(temp);
        setFileDataCount(temp?.length);
    }

    const handleStockMarketPortfolio = (data: any) => {
        let temp: any = [];
        for (var i = 0; i < data.length; i++) {
            if (!data[i]["security"]?.trim() || !data[i]["market"]?.trim()) {
                setfileData([]);
                setFileDataCount(0);
                setFileName("")
                return toast.error(
                    "Security and market must be enerted in all row"
                );
            }
            temp.push({
                code: data[i]["security"],
                market: data[i]["market"],
                total_units: data[i]["total_units"],
                unit: data[i]["available_units"],
                average_cost_per_unit: data[i]["average_cost_unit"],
                amount: data[i]["total_cost_amount"],
                market_rate_per_unit: data[i]["market_rate_unit"],
                market_value: data[i]["market_value"],
                unrealized_gain_loss: data[i]["unrealized_gain_loss"],
                investment_percentage_market_value:
                    data[i]["investment_as_percentage_of_market_value"],
            });
        }
        setfileData(temp);
        setFileDataCount(temp?.length);
    }

    const handleTermPortfolio = (data: any) => {
        let temp: any = [];
        for (var i = 0; i < data.length; i++) {
            if (data[i]["from_date"] !== undefined) {
                data[i]["from_date"] =
                    data[i].from_Date === ""
                        ? ""
                        : moment(data[i].from_Date).format("YYYY-MM-DD");
            }
            if (data[i]["to_date"] !== undefined) {
                data[i]["to_date"] =
                    data[i].to_date === ""
                        ? ""
                        : moment(data[i].to_date).format("YYYY-MM-DD");
            }
            if (
                !data[i]["code"]?.trim() ||
                !data[i]["type"]?.trim() ||
                !data[i]["principal_amount"]?.trim() ||
                !data[i]["interest_rate"]?.trim() ||
                !data[i]["from_date"]?.trim() ||
                !data[i]["to_date"]?.trim() ||
                !data[i]["bank"]?.trim() ||
                !data[i]["branch"]?.trim()
            ) {
                setfileData([]);
                setFileDataCount(0);
                setFileName("")
                return toast.error("Kinldly Fill all details in all row");
            }

            temp.push({
                code: data[i]["code"],
                name: data[i]["type"],
                principal_amount: data[i]["principal_amount"],
                interest_rate: data[i]["interest_rate"],
                from_date: data[i]["from_date"],
                to_date: data[i]["to_date"],
                bank: data[i]["bank"],
                branch: data[i]["branch"],
            });
        }

        setfileData(temp);
        setFileDataCount(temp?.length);
    }


    const upload = async (e: any) => {
        if (e?.target.files[0] && e.target.value) {
            setFileError("");
            setfileData(null);
            let file = e?.target.files[0];

            let type = file?.name?.substring(file?.name?.lastIndexOf(".") + 1);
            if (type === "xlsx" || type === "csv") {
                setFile(file);
                setFileName(file?.name);
                //start

                const reader = new FileReader();
                const rABS = !!reader.readAsBinaryString;
                reader.onload = (e) => {
                    /* Parse data */
                    const bstr = e.target?.result;
                    const wb = xls.read(bstr, { type: rABS ? "binary" : "array" });
                    /* Get first worksheet */
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    /* Convert array of arrays */
                    const data: any = xls.utils.sheet_to_json(ws, {
                        header: 2,
                        raw: false,
                        defval: "",
                        dateNF: "YYYY-MM-DD",
                    });
                    // if file is empty 
                    if (data?.length === 0) {
                        toast.error("File Should not be empty")
                        setfileData([]);
                        setFileDataCount(0);
                        setFileName("")
                        return
                    }
                    // check if uploaded file doesn not contain any other key that is not present in sample file
                    const uploadedHeaders = Object.keys(data[0])?.filter((ele) => !ele?.includes("__EMPTY"))?.map((item1) => item1?.trim()); // remvoving spaces for better matching
                    const headersMatchMMP =
                        fileKeysMMP?.length > uploadedHeaders?.length ?
                            fileKeysMMP.every(header => {
                                return uploadedHeaders.includes(header?.trim())
                            }) :
                            uploadedHeaders.every(header => {
                                return fileKeysMMP.includes(header?.trim())
                            });
                    const headersMatchSMP =
                        fileKeysSMP?.length > uploadedHeaders?.length ?
                            fileKeysSMP.every(header => {
                                return uploadedHeaders.includes(header?.trim())
                            }) :
                            uploadedHeaders.every(header => {
                                return fileKeysSMP.includes(header?.trim())
                            });
                    const headersMatchTDP =
                        fileKeysTDP?.length > uploadedHeaders?.length ?
                            fileKeysTDP.every(header => {
                                return uploadedHeaders.includes(header?.trim())
                            }) :
                            uploadedHeaders.every(header => {
                                return fileKeysTDP.includes(header?.trim())
                            });


                    //  let jsonarray:any = [];
                    if (data.length > 0) {
                        if (headersMatchMMP) {
                            handleMoneyMarketValue(data)
                        }
                        else if (headersMatchTDP) {
                            handleTermPortfolio(data)
                        }
                        else if (headersMatchSMP) {
                            handleStockMarketPortfolio(data)
                        }
                        // filter those keys which has ___Empty 
                        // const filteredData = data.map(obj => {
                        //     return Object.fromEntries(
                        //         Object.entries(obj).filter(([key]) => !key.startsWith('__EMPTY'))
                        //     );
                        // });
                        // setfileData(filteredData);
                        // setFileDataCount(data.length);
                    }

                };
                if (rABS) reader.readAsBinaryString(file);
                else reader.readAsArrayBuffer(file);
                // end 2
            } else {
                toast.error("Please Upload Correct Format of File");
                setfileData([]);
                setFileDataCount(0);
                setFileName("")
            }
            // removing value so that user can upload same file again
            e.target.value = ""
        }

    };


    return (
        <>
            <div className="content">
                <Row>
                    <Col md="12">
                        <Container fluid>
                            <ToastContainer limit={1} />
                            <div className="card">
                                <div className="">
                                    <div className="card-header">
                                        <h4 className="card-title">
                                            Legacy Fund Portfolios Bulk Upload
                                            <Dropdown className="float-right transaction_dropdown">
                                                <Dropdown.Toggle variant="dark" id="dropdown-basic">
                                                    Download Samples
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu
                                                    style={{
                                                        width: "100%",
                                                        maxHeight: "300px",
                                                        overflow: "auto",
                                                        backgroundColor: theme == "dark" ? "rgb(30, 30, 47)" : ""
                                                    }}
                                                >
                                                    {downloadSampleArr?.map((item, index) => (
                                                        <Dropdown.Item
                                                            style={{
                                                                color: "#9a9a9a"
                                                            }}
                                                            key={index}
                                                            href={
                                                                item?.label == "Term Deposit Portfolio" ?
                                                                    `${env.REACT_APP_SAMPLE_URL}${item?.path}` :
                                                                    `${env.REACT_APP_SAMPLE_URL}TXN/${item?.path}`
                                                            }
                                                            download
                                                        >
                                                            {(item?.label)?.toUpperCase()}
                                                        </Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </h4>
                                    </div>
                                    <div className="card-body">
                                        <Row className="mb-3">
                                            <Col md="6">
                                                <label>Choose File </label>
                                                <div
                                                    className="form-control multi-input ml-auto"
                                                    style={{
                                                        cursor: "pointer"
                                                    }}
                                                    onClick={() => myRef1?.current?.click()}
                                                >
                                                    <div className="form-group mb-0">
                                                        <div className="fom-control ml-2">
                                                            {fileName === "" ? "Upload File" : fileName}
                                                        </div>
                                                        <input
                                                            className="form-control"
                                                            type="file"
                                                            ref={myRef1}
                                                            style={{ display: "none" }}
                                                            multiple={false}
                                                            onChange={(e) => {
                                                                upload(e)
                                                            }}
                                                        />
                                                        {fileError ? (
                                                            <p className="error-labels error-message2">
                                                                {fileError}
                                                            </p>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </div>
                                                </div>
                                                {fileUploadingFlag && (
                                                    <img src="assets/loader.svg" width="50" />
                                                )}
                                            </Col>
                                        </Row>
                                        {
                                            fileData?.length > 0 ? (
                                                <div className="table-responsive">
                                                    <JsonToTable
                                                        styles={{
                                                            colors: theme == "dark" ? "#a2b0d4" : "black"
                                                        }}
                                                        json={fileData} />
                                                </div>
                                            ) : (
                                                fileName ?
                                                    <Row className="d-flex justify-content-center my-3">
                                                        <i
                                                            className="fa fa-spinner fa-spin fa-3x"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </Row> : null
                                            )
                                        }
                                        Total Rows:{" "}
                                        <span className="text-primary mt-3">{fileDataCount} </span>
                                        <div className="mt-4">
                                            <button
                                                className="btn btn-primary"
                                                disabled={Boolean(loading)}
                                            >
                                                {loading ? (
                                                    <>
                                                        <span
                                                            className="spinner-border login-txt spinner-border-sm"
                                                            role="status"
                                                            aria-hidden="true"
                                                        ></span>
                                                        <span className="login-txt"> Loading...</span>
                                                    </>
                                                ) : (
                                                    <span>Upload</span>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Container>
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default LegacyFundPortfolioUploader;
